import _ from 'lodash';
import { PlacementPhase } from './GameState';

export function getRemainingTroops(phase: PlacementPhase) {
    const distributed = Object.values(phase.troopDistribution)
        .reduce(_.add, 0);
    return phase.availableTroops - distributed;
}
